<template>
  <div class="check-picker">
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ minHeight: '30%' }"
      @open="() => {searchQuery = ''}"
      @close="onCancel">
      <!-- <template v-if="columns.length === 0">
        <div style="text-align: center;margin-top: 30px;"><van-loading>数据加载中，请稍等...</van-loading></div>
      </template> -->
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel">
        <template #default>
          <div class="check-picker__header">
            <div class="check-picker__header__btns">
              <div>
                <el-button
                  size="small"
                  type="info"
                  @click="onCancel">
                  取消
                </el-button>
                <el-button
                  size="small"
                  @click="onClear">
                  清空
                </el-button>
              </div>
              <el-button
                class="check-picker-confirm"
                size="small"
                type="primary"
                @click="onConfirm">
                确定
              </el-button>

            </div>
            <div class="check-picker__header__search">
              <van-search
                v-model="searchQuery"
                placeholder="请输入关键字搜索"
                show-action>
                <template #action>
                  <div @click="onSearch">搜索</div>
                </template>
              </van-search>
            </div>
          </div>

        </template>
        <template #option="option">
          <van-checkbox-group v-model="selectedValues">
            <template v-if="type === 'channel' || type === 'client'">
              <van-checkbox :name="option.id" :checked-color="'#e7635e'">
                {{ option.accountName }}
              </van-checkbox>
            </template>
            <template v-else-if="type === 'channelName'">
              <van-checkbox :name="option.accountName" :checked-color="'#e7635e'">
                {{ option.accountName }}
              </van-checkbox>
            </template>
            <template v-else>
              <van-checkbox :name="model ? option.id : option.name" :checked-color="'#e7635e'">
                {{ option.name }}
              </van-checkbox>
            </template>
          </van-checkbox-group>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: "CheckPicker",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(newVal) {
      this.selectedValues = newVal; // 监听父组件传递的value，更新本地选择的值
    }
  },
  data() {
    return {
      selectedValues: [], // 保存选择的值
      searchQuery: "",
    };
  },
  methods: {
    onConfirm() {
      this.$emit("confirm", this.selectedValues);
    },
    onCancel() {
      this.$emit("cancel");
    },
    onClear() {
      this.selectedValues = []
    },
    onSearch() {
      this.$emit("search", this.searchQuery);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-picker {
  ::v-deep .van-picker__toolbar {
    height: unset;
  }
  .check-picker-confirm {
    background-color: #e7635e;
    border: none;
  }
  .check-picker__header {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px;
  }

  .check-picker__header__btns {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .check-picker__header__search {
    width: 100%;
  }
}
/* 添加必要的样式 */
</style>